import { configuratorInterface } from '../systems/configurator-interface'
import { sunlifeTheme } from '../theme'

export const getThemeHandler = configuratorInterface.createGetThemeHandler(() => {
  return sunlifeTheme
})
